<div class="partner-logos-container" *ngIf="control?.action == 'on' && league?.partnerLogosUrls?.length > 0">
  <div class="logos-wrapper">
    <img alt="partner logo" class="partner-logo" [src]="league.partnerLogosUrls[(control.index % league.partnerLogosUrls.length) || 0]"/>
  </div>
</div>
